<div class="betslip-result-links">
    <ms-item
        class="alert-betslip-confirmation"
        *ngIf="liveAlert && isNativeAlertEnabled() && !failedSlips.length"
        [title]="sitecore.betslip.messages.NativeAlerts"
        (click)="nativeAlertClicked($event)">
        <ms-alert #nativeAlertButton item-icon tracking="betslipconfirmation" class="alert-betslipconfirmation-view" [model]="picks"></ms-alert>
    </ms-item>
    <bs-digital-quick-links *ngIf="shouldShowQuickLinks" [context]="'BetConfirmation'" (linkClicked)="onQuickLinkClicked()"></bs-digital-quick-links>

    <div class="deposit-on-confirmation" *ngIf="showDeposit() && succeededSlips.length">
        <div class="info" [innerHTML]="depositInfo" (click)="showDepositDetails()"></div>
        <button class="btn" [innerHTML]="sitecore.betslip.messages.DepositButtonOnConfirmation" (click)="redirectToCashier()"></button>
    </div>

    <ng-container *ngIf="succeededSlips.length === 1 && shouldShowShareMyBet">
        <bs-result-share-my-bet [slip]="succeededSlips[0]" [trackingInformation]="trackingInformation"></bs-result-share-my-bet>
    </ng-container>
</div>
